import ReactGA from 'react-ga';
import Router from 'next/router';
import { GOOGLE_ANALYTICS_ID } from 'utils/constants';

export const googleAnalyticsPageView = url => {
  ReactGA.set({ page: url || window.location.pathname + window.location.search });
  ReactGA.pageview(url || window.location.pathname + window.location.search);
};

export const initializeGoogleAnalytics = () => {
  ReactGA.initialize(GOOGLE_ANALYTICS_ID);
  googleAnalyticsPageView();
};

export const googleAnalyticsEffect = () => {
  initializeGoogleAnalytics();
  Router.events.on('routeChangeComplete', googleAnalyticsPageView);
  return () => {
    Router.events.off('routeChangeComplete', googleAnalyticsPageView);
  };
};
